import { percentage } from "~/lib/format";

export function ProgressBar({ label, value }: { label: string; value: number }) {
    const progress = percentage(value);
    if (progress === null) return null;
    return (
        <div className="font-body relative flex w-full items-center justify-between bg-blue-10">
            <span className="absolute left-4 top-2">{label}</span>
            <div className="h-10 bg-blue-30" style={{ width: progress }} />
            <span className="absolute right-4 top-2">{progress}</span>
        </div>
    );
}
